import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import "../Asociados/createAsociados.css";
import "../Productos/createProduct.css";

import { useFormik } from "formik";
import { pedidoEspecialFormValidate } from "../../../../helper/validate";
import toast from "react-hot-toast";
import * as api from "helper/helper";
import "./../formsCommons.css";

import invalidClass, { formikExtra } from "../../helperFunctions/helpers";
import LoadingButton from "../LoadingButton/LoadingButton";
import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";

import AutocompleteGo from "../Autocomplete/AutocompleteGo";
import { format } from "date-fns";
import { withMask } from "use-mask-input";
import { onlyNumbers } from "helper/tools";

const CreatePedidoEspecial = forwardRef(({ item, reloadProveedor }, ref) => {
  const modalRef = useRef();
  const buttonCancelModalRef = useRef();

  const fieldsSetup = useRef({});

  const refAutoProveedores = useRef(null);
  const refAutoMarcas = useRef(null);

  const [proveedores, setProveedores] = useState([]);
  const [marcas, setMarcas] = useState([]);

  const [categorias, setCategorias] = useState([
    { id: 0, nombre: "Selecciona una categoria..." },
  ]);

  const [generos, setGeneros] = useState([
    { id: 0, nombre: "Selecciona un genero..." }, //tipo de producto..." },
  ]);

  /// CHECAR  useTraceUpdate(props, "CreateProduct");
  const [isActiveDisabled, setIsActiveDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [modalData, setModalData] = useState(null);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const createMode = item == null || (item && Object.keys(item).length === 0);

  useEffect(() => {
    console.log("---> change item: " + item);
    let isActiveDisable = createMode;
    setIsActiveDisabled(isActiveDisable);

    if (item == null) {
      return;
    }

    formik?.resetForm();
  }, [item]);

  /*

  const [categories] = useState([
    { id: 0, nombre: "Selecciona una categoria..." },
    ...CategoriasProducto,
  ]);*/

  let tags = null;

  const fetchData = async () => {
    const responseProveedores = await api.proveedores().catch((e) => {
      toast.error("Error al pedir Proveedores.");
    });
    if (!responseProveedores) return;

    setProveedores([...proveedores, ...responseProveedores.data]);

    const response = await api.marcas().catch((e) => {
      toast.error("Error al pedir usuarios.");
    });
    if (!response) return;

    setMarcas([...marcas, ...response.data]);

    const responseGenero = await api.generos().catch((e) => {
      toast.error("Error al pedir generos.");
    });
    if (!responseGenero) return;

    setGeneros([...generos, ...responseGenero.data]);

    const responseCategporiasCompras = await api
      .categoriasCompras()
      .catch((e) => {
        toast.error("Error al pedir Categorias Compras.");
      });
    if (!responseCategporiasCompras) return;

    setCategorias([...categorias, ...responseCategporiasCompras.data]);
  };

  useEffect(() => {
    formik?.resetForm();

    const newPermissions = PermissionsForSection(Sections.Productos);
    setPermissions(newPermissions);

    fetchData();
  }, []);

  let initialValues = {
    id: 0,
    nombre: "",
    cantidad: 0,
    proveedorId: 0,
    marcaId: 0,
    generoId: 0,
    categoriaCompraId: 0,

    precioCosto: 0,
    precioPublico: 0,
    totalPrecioPublico: 0,
    totalPrecioCosto: 0,
    margen: 45,

    fechaOrden: "",

    //activo: true,
  };

  //tagRef.current?.removeAll();
  if (!createMode) {
    //const images = item.productImagePathsString?.split(",") ?? [];
    /*images = images.map((el) => ImagePathBuilder.to(el));

    setInsideImages(images);
    */
    //--dragDropRef.current.setSelectedFiles(images);
    //let tags = tagRef.current.getTags().values.split(",");
    //tags = tags.map(el => el.trim());

    /*values.tags = tagRef.current.getTags().values.join(", ");
      tagRef.current.
      array = array.map(el => el.trim());*/

    const fechaOrden = format(item.fechaOrden, "yyyy-MM-dd");

    initialValues = {
      id: item.id,
      nombre: item.nombre,
      cantidad: item.cantidad,
      proveedorId: item.proveedor.id,
      marcaId: item.marca.id,
      generoId: item.genero.id,
      categoriaCompraId: item.categoriaCompra.id,

      precioCosto: item.costo,
      precioPublico: item.precioPublico,
      totalPrecioPublico: item.totalPrecioPublico,
      totalPrecioCosto: item.totalPrecioCosto,
      margen: item.margen,

      fechaOrden: fechaOrden,
    };
  }

  //console.log("-->");
  //console.log(initialValues);

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validate: pedidoEspecialFormValidate,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { props, setSubmitting }) => {
      //  values.tags = tagRef.current.getTags().values.join(",");
      //is - invalid;
      console.log(tags);

      /*
      No enviar “NumProducto”, 
      “CategoriaId”, 
      “PrecioCosto” y 
      “PrecioVenta” en Crear/Editar.
*/
      /*
      delete values["precioCosto"];
      delete values["precioVenta"];
      delete values["sku"];*/

      setIsLoading(true);

      if (values.id === 0) {
        const toastId = toast.loading("Creando Compra Especial...");
        let response = await api
          .createOrdenesComprasEspeciales(values, null)
          .catch((e) => {
            toast.dismiss(toastId);
            setIsLoading(false);
            if (e.esError && e.codigoError && e.mensaje) {
              toast.error(`Error al crear Compra Especial. ${e.mensaje}`);
              return;
            }
            toast.error("Error al crear Compra Especial.");
          });

        toast.dismiss(toastId);
        setIsLoading(false);

        if (!response) return;

        toast.success("Compra Especial creado.");
        reloadProveedor();

        buttonCancelModalRef.current.click();
      } else {
        const toastId = toast.loading("Actualizando Compra Especial...");
        setIsLoading(true);
        const response = await api
          .updateProveedor(values.id, values)
          .catch((e) => {
            setIsLoading(false);
            toast.dismiss(toastId);
            toast.error("Error al actualizar Compra Especial.");
          });
        if (!response) return;

        /*  const responseActivo = await api
          .activarProveedor(values.id, values.activo)
          .catch((e) => {
            setIsLoading(false);
            toast.dismiss(toastId);
            toast.error("Error al actualizar activo Proveedor.");
          });*/

        toast.dismiss(toastId);
        setIsLoading(false);

        //    if (!responseActivo) return;

        setIsLoading(false);

        buttonCancelModalRef.current.click();

        toast.dismiss(toastId);
        toast.success("Proveedor actualizado.");
        reloadProveedor();
      }
    },
  });

  useImperativeHandle(ref, () => ({
    getValue: () => {
      return formik.values;
    },
    toggleModal: () => {
      formik?.resetForm();
      modalRef.current.click();
    },
  }));

  function calculatePVP(item) {
    const { margen, precioCosto, cantidad } = item;
    /*
    PVP = precioCosto / (100%-Margen%)
    PVP = precioCosto / (1-MArgen decimal)
    */
    const margenDec = margen / 100;
    const precioPublico = precioCosto / (1 - margenDec);
    const totalPrecioPublico = cantidad * precioPublico;
    const totalPrecioCosto = precioCosto * cantidad;

    return { precioPublico, totalPrecioPublico, totalPrecioCosto };
  }

  function calculateMargenPVP(item) {
    const { precioCosto, precioPublico } = item;
    /*
    PVP = precioCosto / (100%-Margen%)
    PVP = precioCosto / (1-MArgen decimal)
    */
    const margenDec = 1 - precioCosto / precioPublico;
    const margen = 100 * margenDec;

    return margen;
  }
  ///

  return (
    <>
      <button
        ref={modalRef}
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropCrearProovedor"
        hidden
      >
        Abrir Crear Producto
      </button>

      <div
        className="modal fade modal-lg"
        id="staticBackdropCrearProovedor"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropCrearProovedorLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                {createMode ? "Crear" : "Editar"} Pedido Especial
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div
              className="modal-body"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <form
                className="row g-3"
                onSubmit={(event) => {
                  event.preventDefault();
                  return false;
                }}
              >
                <div className="form-control">
                  <h5>Información General</h5>

                  <div className="row">
                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Nombre
                      </label>
                      <input
                        type="text"
                        className={`form-control ${invalidClass(
                          formik.errors.nombre,
                        )}`}
                        id="validationName"
                        aria-describedby="emailHelp"
                        {...formik.getFieldProps("nombre")}
                        {...formikExtra.upperCase("nombre", formik)}
                      />
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.nombre}
                      </div>
                    </div>

                    {/*<div className="col-2 align-container-center">
                      <div className="container-center-horizontal">
                        <div className="form-check form-switch container-center-vertical">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="flexSwitchCheckDefault"
                            {...formik.getFieldProps("activo")}
                            checked={formik.values.activo}
                            disabled={
                              isActiveDisabled || !permissions.canActivar
                            }
                          />
                          <span>
                            <label
                              className="form-check-label"
                              htmlFor="flexSwitchCheckDefault"
                            >
                              Activo
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>*/}

                    <div className="col-2">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Cantidad
                      </label>
                      <input
                        type="number"
                        min="0"
                        max="20"
                        className={`form-control ${invalidClass(
                          formik.errors.cantidad,
                        )}`}
                        id="validationName"
                        aria-describedby="emailHelp"
                        value={formik.values.cantidad}
                        onChange={(e) => {
                          const cantidad = e.currentTarget.value;
                          const totalPrecioCosto =
                            formik.values.precioCosto * cantidad;
                          const totalPrecioPublico =
                            formik.values.precioPublico * cantidad;

                          formik.setFieldValue("cantidad", cantidad);

                          formik.setFieldValue(
                            "totalPrecioCosto",
                            totalPrecioCosto,
                          );
                          formik.setFieldValue(
                            "totalPrecioPublico",
                            Math.round(totalPrecioPublico),
                          );

                          //{...formik.getFieldProps("cantidad")}

                          /*  validateAgregarProducto(
                                                  e.currentTarget.value,
                                                  formik.values.productId
                                                );*/
                        }}
                        disabled={!createMode}
                      />
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.cantidad}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col">
                      <label
                        htmlFor="validationApellidoPaterno"
                        className="form-label"
                      >
                        Proveedor
                      </label>
                      <AutocompleteGo
                        ref={refAutoProveedores}
                        options={proveedores}
                        placeholder="Buscar Proveedor..."
                        className={`form-select ${invalidClass(
                          formik.errors.proveedorId,
                        )}`}
                        value={formik.values.proveedorId}
                        onChange={(e) => {
                          console.log(e);
                          const id = e == null ? 0 : parseInt(e.id);
                          formik.setFieldValue("proveedorId", id);
                        }}
                        readOnly={!createMode}
                      >
                        <div className="valid-feedback">Looks good!</div>
                        <div className="invalid-feedback">
                          {formik.errors.proveedorId}
                        </div>
                      </AutocompleteGo>
                    </div>
                    <div className="col">
                      <label
                        htmlFor="validationApellidoPaterno"
                        className="form-label"
                      >
                        Marcas
                      </label>
                      <AutocompleteGo
                        ref={refAutoMarcas}
                        options={marcas}
                        placeholder="Buscar Marcas..."
                        className={`form-select ${invalidClass(
                          formik.errors.marcaId,
                        )}`}
                        value={formik.values.marcaId}
                        onChange={(e) => {
                          console.log(e);
                          const id = e == null ? 0 : parseInt(e.id);
                          formik.setFieldValue("marcaId", id);
                        }}
                        readOnly={!createMode}
                      >
                        <div className="valid-feedback">Looks good!</div>
                        <div className="invalid-feedback">
                          {formik.errors.marcaId}
                        </div>
                      </AutocompleteGo>
                    </div>
                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Genero
                      </label>

                      <select
                        className={`form-select ${invalidClass(
                          formik.errors.generoId,
                        )}`}
                        id="inputGroupSelect01"
                        {...formik.getFieldProps("generoId")}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "generoId",
                            parseInt(e.target.value),
                          );
                        }}
                      >
                        {generos.map((item) => (
                          <option value={item.id}>{item.nombre}</option>
                        ))}
                      </select>
                      <div className="valid-feedback">Looks good! WPWPWPW</div>
                      <div className="invalid-feedback">
                        {formik.errors.generoId}
                      </div>
                    </div>

                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Categoria Compra
                      </label>

                      <select
                        className={`form-select ${invalidClass(
                          formik.errors.categoriaCompraId,
                        )}`}
                        id="inputGroupSelect01"
                        {...formik.getFieldProps("categoriaCompraId")}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "categoriaCompraId",
                            parseInt(e.target.value),
                          );
                        }}
                      >
                        {categorias.map((item) => (
                          <option value={item.id}>{item.nombre}</option>
                        ))}
                      </select>
                      <div className="valid-feedback">Looks good! WPWPWPW</div>
                      <div className="invalid-feedback">
                        {formik.errors.categoriaCompraId}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Precio Costo
                      </label>
                      <input
                        ref={withMask("currency", {
                          groupSeparator: ",",
                          digits: 0,
                          numericInput: true,
                          rightAlign: false,
                          allowMinus: false,
                        })}
                        type="text"
                        min="0"
                        className={`form-control ${invalidClass(
                          formik.errors.precioCosto,
                        )}`}
                        id="validationName"
                        aria-describedby="emailHelp"
                        value={formik.values.precioCosto}
                        onChange={(e) => {
                          const aValue = onlyNumbers(e.currentTarget.value);
                          const precioCosto = aValue;
                          const cantidad = formik.values.cantidad;
                          const margen = formik.values.margen;

                          const {
                            precioPublico,
                            totalPrecioPublico,
                            totalPrecioCosto,
                          } = calculatePVP({ margen, precioCosto, cantidad });

                          /*const totalPrecioCosto = precioCosto * cantidad;
                          const totalPrecioPublico =
                            formik.values.precioPublico * cantidad;*/

                          formik.setFieldValue(
                            "totalPrecioCosto",
                            totalPrecioCosto,
                          );
                          formik.setFieldValue(
                            "totalPrecioPublico",
                            Math.round(totalPrecioPublico),
                          );
                          formik.setFieldValue(
                            "precioPublico",
                            Math.round(precioPublico),
                          );

                          formik.setFieldValue("precioCosto", aValue);

                          /*  validateAgregarProducto(
                                                e.currentTarget.value,
                                                formik.values.productId
                                              );*/
                        }}
                        disabled={!createMode}
                      />
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.precioCosto}
                      </div>
                    </div>

                    <div className="col">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Total Precio Costo
                      </label>
                      <input
                        ref={withMask("currency", {
                          groupSeparator: ",",
                          digits: 0,
                          numericInput: true,
                          rightAlign: false,
                          allowMinus: false,
                        })}
                        type="text"
                        min="0"
                        className={`form-control ${invalidClass(
                          formik.errors.totalPrecioCosto,
                        )}`}
                        id="validationName"
                        aria-describedby="emailHelp"
                        value={formik.values.totalPrecioCosto}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "totalPrecioCosto",
                            e.currentTarget.value,
                          );
                          //{...formik.getFieldProps("cantidad")}

                          /*  validateAgregarProducto(
                                              e.currentTarget.value,
                                              formik.values.productId
                                            );*/
                        }}
                        disabled={true}
                      />
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.totalPrecioCosto}
                      </div>
                    </div>

                    <div className="col">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Margen
                      </label>
                      <input
                        type="number"
                        min="40"
                        max="99"
                        className={`form-control ${invalidClass(
                          formik.errors.margen,
                        )}`}
                        id="validationName"
                        aria-describedby="emailHelp"
                        value={formik.values.margen}
                        onChange={(e) => {
                          const margen = e.currentTarget.value;
                          formik.setFieldValue("margen", margen);

                          /*
                          PVP = precioCosto / (100%-Margen%)
                          PVP = precioCosto / (1-MArgen decimal)
                          */
                          const precioCosto = formik.values.precioCosto;
                          const cantidad = formik.values.cantidad;

                          const { precioPublico, totalPrecioPublico } =
                            calculatePVP({
                              margen,
                              precioCosto,
                              cantidad,
                            });

                          formik.setFieldValue(
                            "totalPrecioPublico",
                            Math.round(totalPrecioPublico),
                          );
                          formik.setFieldValue(
                            "precioPublico",
                            Math.round(precioPublico),
                          );
                        }}
                        disabled={!createMode}
                      />
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.margen}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label"
                        >
                          Precio Publico
                        </label>
                        <input
                          ref={withMask("currency", {
                            groupSeparator: ",",
                            digits: 0,
                            numericInput: true,
                            rightAlign: false,
                            allowMinus: false,
                          })}
                          type="text"
                          min="0"
                          className={`form-control ${invalidClass(
                            formik.errors.precioPublico,
                          )}`}
                          id="validationName"
                          aria-describedby="emailHelp"
                          value={formik.values.precioPublico}
                          onChange={(e) => {
                            const precioPublico = onlyNumbers(
                              e.currentTarget.value,
                            );
                            const precioCosto = formik.values.precioCosto;
                            const cantidad = formik.values.cantidad;

                            const margen = calculateMargenPVP({
                              precioCosto,
                              precioPublico,
                            });

                            const { totalPrecioPublico } = calculatePVP({
                              margen,
                              precioCosto,
                              cantidad,
                            });

                            formik.setFieldValue(
                              "totalPrecioPublico",
                              Math.round(totalPrecioPublico),
                            );
                            formik.setFieldValue(
                              "precioPublico",
                              precioPublico,
                            );

                            formik.setFieldValue("margen", margen);
                          }}
                          disabled={!createMode}
                        />
                        <div className="valid-feedback"></div>
                        <div className="invalid-feedback">
                          {formik.errors.precioPublico}
                        </div>
                      </div>

                      <div className="col">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label"
                        >
                          Total Precio Publico
                        </label>
                        <input
                          ref={withMask("currency", {
                            groupSeparator: ",",
                            digits: 0,
                            numericInput: true,
                            rightAlign: false,
                            allowMinus: false,
                          })}
                          type="text"
                          min="0"
                          className={`form-control ${invalidClass(
                            formik.errors.totalPrecioPublico,
                          )}`}
                          id="validationName"
                          aria-describedby="emailHelp"
                          value={formik.values.totalPrecioPublico}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "totalPrecioPublico",
                              e.currentTarget.value,
                            );
                          }}
                          disabled={true}
                        />
                        <div className="valid-feedback"></div>
                        <div className="invalid-feedback">
                          {formik.errors.totalPrecioPublico}
                        </div>
                      </div>

                      <div className="col align-self-start">
                        <label htmlFor="validationDOB" className="form-label">
                          Fecha de Orden
                        </label>
                        <input
                          type="date"
                          min="1900-01-01"
                          className={`form-control ${invalidClass(
                            formik.errors.fechaOrden,
                          )}`}
                          id="validationDOB"
                          aria-describedby="emailHelperwerwer"
                          placeholder="YYYY-MM-DD"
                          disabled={fieldsSetup.current.fechaOrden}
                          {...formik.getFieldProps("fechaOrden")}
                          value={formik.values.fechaOrden}
                          onChange={(e) => {
                            formik.setFieldValue("fechaOrden", e.target.value);
                          }}
                        />
                        <div className="valid-feedback">Looks good!</div>
                        <div className="invalid-feedback">
                          {formik.errors.fechaOrden}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="mb-3"></div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    ref={buttonCancelModalRef}
                  >
                    Cancelar
                  </button>
                  <LoadingButton
                    style={{ height: "38px" }}
                    onClick={(e) => {
                      formik.handleSubmit();
                    }}
                    text={"Guardar"}
                    loadingText={"Guardando..."}
                    isLoading={isLoading}
                    hidden={!permissions.canEdit}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default CreatePedidoEspecial;
